import { create } from 'zustand';
import Cookie from 'js-cookie'
import user from '@/utils/user';
import type { EnterpriseInfo, AuthType } from '@/services/login/types';



// 第三方登录跨组件通信
interface ThirdInfo {
  enterpriseCode?: string, // 企业号
  openId?: string, // 微信openId
  unionId?: string, // 微信unionID
  type: string,
  corpId?: string, // 企微企业id
  qwUserId?: string, // 企微用户id
  preLoginCaptcha?: string, // 预登录验证码
  mobile?: string, // 手机号
  authType?: AuthType, // 登录来源
  dingTalkUserId?: string, // 钉钉用户id
  feishuUserId?: string, // 飞书用户id
  feishuUserName?: string, // 飞书用户名
}

interface LoginState {
  loginStatus: boolean,
  thirdInfo: ThirdInfo | null,
  showBindAccount: boolean,
  showSelectAccount: boolean,
  selectAccounts: EnterpriseInfo[],
  showAddInfo: boolean,
}


interface LoginActions {
  login: () => void
  logout: () => void
  setThirdInfo: (thirdInfo: ThirdInfo | null) => void,
  setShowBindAccount: (showBindAccount: boolean) => void,
  setShowSelectAccount: (showSelectAccount: boolean) => void,
  setSelectAccounts: (selectAccounts: EnterpriseInfo[]) => void,
  setShowAddInfo: (showAddInfo: boolean) => void,
}

type LoginStore = LoginState & LoginActions

const userData = user.get()
let initialLogin = !!JSON.parse(window.localStorage.getItem('login') || Cookie.get('login') || null)
if (!userData) { // 如果localStorage中没有userData则删除cookie中的login
  Cookie.remove('login')
  window.localStorage.removeItem('login')
  initialLogin = false
}

export const loginStore = create<LoginStore>((set) => ({
  loginStatus: initialLogin,
  thirdInfo: null,
  showBindAccount: false,
  showSelectAccount: false,
  selectAccounts: [],
  showAddInfo: false,
  login: () => set({ loginStatus: true }),
  logout: () => set({ loginStatus: false, thirdInfo: null }),
  setThirdInfo: (thirdInfo: ThirdInfo | null) => set({ thirdInfo }),
  setShowBindAccount: (showBindAccount: boolean) => set({ showBindAccount: showBindAccount }),
  setShowSelectAccount: (showSelectAccount: boolean) => set({ showSelectAccount: showSelectAccount }),
  setSelectAccounts: (selectAccounts: EnterpriseInfo[]) => set({ selectAccounts: selectAccounts }),
  setShowAddInfo: (showAddInfo: boolean) => set({ showAddInfo: showAddInfo }),
}))

export const useLoginStore = loginStore